import { render } from "./EditorConfirm.vue?vue&type=template&id=2680e8a8"
import script from "./EditorConfirm.vue?vue&type=script&lang=js"
export * from "./EditorConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1770878715/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__